import CustomMenuItem from "./CustomMenuItem";
import React from "react";

export default function CustomMenuItems({items,setActiveItem}) {
  return items?.map(({href, title, attr}, index) => {
    return (
      <CustomMenuItem key={"custom-menu-item-" + index} href={href.slice(1)} text={title} {...attr} setActiveItem={setActiveItem}/>
    )
  });
}
